import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

import { RejectVisit, RejectVisitVariables } from '../../athena/types/RejectVisit';

export const REJECT_VISIT = gql`
  mutation RejectVisit($id: String!, $reason: String!) {
    trippy {
      rejectVisit(input: { id: $id, reason: $reason }) {
        id
      }
    }
  }
`;

export const useRejectVisit = () => {
  return useMutation<RejectVisit, RejectVisitVariables>(REJECT_VISIT);
};
